/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

export function addClass(elem, classname) {
    if (elem) {
        const arr = elem.className.split(' ');
        if (arr.indexOf(classname) === -1) {
            elem.className += ` ${classname}`; // eslint-disable-line no-param-reassign
        }
    }
}

export function removeClass(elem, classname) {
    if (elem) {
        const arr = elem.className.split(' ');
        const newArr = arr.filter(inputClass => inputClass !== classname);
        elem.className = newArr.join(' '); // eslint-disable-line no-param-reassign
    }
}

export function setCSSProperty(elem, property, value, priority = '') {
    if (elem) {
        elem.style.setProperty(property, value, priority);
    }
}

export function convertPixelPropertyToNum(prop) {
    if (prop) {
        return parseFloat(prop.replace('px', ''));
    }
    return 0;
}
